(function(){
    'use strict'

    angular
    .module('app.perfilesAsiento')
    .controller('EditarPerfilAsiento', EditarPerfilAsiento);

    EditarPerfilAsiento.$inject = ['$scope', '$animationsSrv', '$routeParams','PerfilesAsientoService', 'UserInfoService', 'CoreSrv', 'DevengadosService', 'DeduciblesService', 'CuentasContablesService', 'CentrosCostoService', 'logger', '$location'];

    function EditarPerfilAsiento($scope, $animationsSrv, $routeParams, PerfilesAsientoService, UserInfoService, CoreSrv, DevengadosService, DeduciblesService, CuentasContablesService, CentrosCostoService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.editandoPerfil = false;
        vm.editandoDetalle = false;

        vm.perfil = {
            id: 0,
            companiaId: UserInfoService.getCompaniaId(),
            nombre: ''
        };

        vm.tiposRubro = [];
        vm.devengados = [];
        vm.otrosDevengados = [];
        vm.deducibles = [];
        vm.otrosDeducibles = [];
        vm.cuentas = [];
        vm.centrosCosto = [];

        vm.perfilId = $routeParams.id ? $routeParams.id : 0;
        vm.editandoPerfil = vm.perfilId > 0

        vm.detalles = [];
        vm.perfilDetalle = {
            companiaId: UserInfoService.getCompaniaId(),
            tipoRubro: -1,
            rubroId: -1,
            cuentaMayor: -1,
            cuentaAsociadaDebitos: -1,
            cuentaAsociadaCreditos: -1,
            perfilId: vm.perfilId,
            centroCostoId: -1,
            valorBruto: 0,
            producto: '',
            finca: '',
            lote: ''
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getPerfil();
        getPerfilDetalle();

        vm.tiposRubro = CoreSrv.getTiposRubroPerfilAsiento();
        getDevengados();
        getOtrosDevengados();
        getDeducibles();
        getOtrosDeducibles();
        getCuentas();
        getCentrosCosto();

        function getPerfil(){

            if(vm.perfilId != 0){
                var promise = PerfilesAsientoService.getByIdPerfil(vm.perfilId);

                promise
                .then(function(perfil){
                    vm.perfil = perfil;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el perfil: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        function getPerfilDetalle(){

            if(vm.perfilId != 0){
                var promise = PerfilesAsientoService.getAllPerfilDetalle(vm.perfilId);

                promise
                .then(function(detalle){
                    vm.detalles = detalle;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener los detalles del perfil: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        function getDevengados(){
            var promise = DevengadosService.getAll()
            .then(function(devengados){
                vm.devengados = devengados.sort(CoreSrv.dynamicSort("descripcion"));
            })
            .catch(function(error){
                $logger.error('Error al obtener los devengados.');
            }); 
            
            return promise;
        };

        function getOtrosDevengados(){
            var promise = DevengadosService.getAllOtros()
            .then(function(devengados){
                vm.otrosDevengados = devengados.sort(CoreSrv.dynamicSort("descripcion"));
            })
            .catch(function(error){
                $logger.error('Error al obtener los otros devengados.');
            }); 
            
            return promise;
        };

        function getDeducibles(){
            var promise = DeduciblesService.getAll()
            .then(function(deducibles){
                vm.deducibles = deducibles.sort(CoreSrv.dynamicSort("descripcion"));
            })
            .catch(function(error){
                $logger.error('Error al obtener los deducibles.');
            }); 
            
            return promise;
        };

        function getOtrosDeducibles(){
            var promise = DeduciblesService.getAllOtros()
            .then(function(deducibles){
                vm.otrosDeducibles = deducibles.sort(CoreSrv.dynamicSort("descripcion"));
            })
            .catch(function(error){
                $logger.error('Error al obtener los otros deducibles.');
            }); 
            
            return promise;
        };

        function getCuentas(){
            var promise = CuentasContablesService.getAll(UserInfoService.getCompaniaId())
            .then(function(cuentas){
                vm.cuentas = cuentas.sort(CoreSrv.dynamicSort("descripcion"));
            })
            .catch(function(error){
                $logger.error('Error al obtener las cuentas contables.')
            }); 
            
            return promise;
        };

        function getCentrosCosto(){
            var promise = CentrosCostoService.getAll(UserInfoService.getCompaniaId())
            .then(function(centrosCosto){
                vm.centrosCosto = centrosCosto;
            })
            .catch(function(error){
                $logger.error('Error al obtener los centros de costo.')
            }); 
            
            return promise;
        };

        function validateRubroId(){

            $scope.perfilDetalleForm.devengadoId.$setValidity("different", true);
            $scope.perfilDetalleForm.deducibleId.$setValidity("different", true);
            $scope.perfilDetalleForm.otroDevengadoId.$setValidity("different", true);
            $scope.perfilDetalleForm.otroDeducibleId.$setValidity("different", true);

            if(vm.perfilDetalle.tipoRubro == 1)
            {
                if(vm.perfilDetalle.rubroId == -1){
                    $scope.perfilDetalleForm.devengadoId.$setValidity("different", false);
                }
                else{
                    $scope.perfilDetalleForm.devengadoId.$setValidity("different", true);
                }                
            }
            else if(vm.perfilDetalle.tipoRubro  == 2)
            {
                if(vm.perfilDetalle.rubroId == -1){
                    $scope.perfilDetalleForm.deducibleId.$setValidity("different", false);
                }
                else{
                    $scope.perfilDetalleForm.deducibleId.$setValidity("different", true);
                }                
            }
            else if(vm.perfilDetalle.tipoRubro  == 3)
            {
                if(vm.perfilDetalle.rubroId == -1){
                    $scope.perfilDetalleForm.otroDevengadoId.$setValidity("different", false);
                }
                else{
                    $scope.perfilDetalleForm.otroDevengadoId.$setValidity("different", true);
                }                
            }
            else if(vm.perfilDetalle.tipoRubro  == 4)
            {
                if(vm.perfilDetalle.rubroId == -1){
                    $scope.perfilDetalleForm.otroDeducibleId.$setValidity("different", false);
                }
                else{
                    $scope.perfilDetalleForm.otroDeducibleId.$setValidity("different", true);
                }                
            }

        };

        vm.devengadosChange = function(){
            validateRubroId();
        };

        vm.deduciblesChange = function(){
            validateRubroId();
        };

        vm.otrosDevengadoChange = function(){
            validateRubroId();
        };

        vm.otrosDeducibleChange = function(){
            validateRubroId();
        };

        function validateTiposRubro(){
            if(vm.perfilDetalle.tipoRubro == -1){
                $scope.perfilDetalleForm.tipoRubro.$setValidity("different", false);
            }
            else{
                $scope.perfilDetalleForm.tipoRubro.$setValidity("different", true);
            }
        };

        vm.tiposRubroChange = function(){
            validateTiposRubro();
            vm.perfilDetalle.rubroId = -1;
        };

        function validateCentrosCosto(){
            if(vm.perfilDetalle.centroCostoId == -1){
                $scope.perfilDetalleForm.centroCostoId.$setValidity("different", false);
            }
            else{
                $scope.perfilDetalleForm.centroCostoId.$setValidity("different", true);
            }
        };

        vm.centrosCostoChange = function(){
            validateCentrosCosto();
        };

        function doFormDetalleValidations(){
            validateTiposRubro();
            validateCentrosCosto();
            validateRubroId();
        }

        vm.nuevo = function(){
            clearPerfilData();
            clearPerfilDetalleData();
            vm.editandoPerfil = false;
            vm.editandoDetalle = false;
        };

        vm.save = function(){

            $scope.submitted = true;
            
            if($scope.perfilForm.$valid){
                if(!vm.perfil.id){
                    savePerfil();
                }
                else if($scope.perfilForm.$dirty){
                    updatePerfil();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function savePerfil() {
            var promise = PerfilesAsientoService.savePerfil(vm.perfil);
            
            promise
            .then(function(response){
                logger.success('Perfil creado con éxito.');
                vm.perfilId = response.data;
                vm.perfilDetalle.perfilId = vm.perfilId;
                vm.editandoPerfil = true;
                getPerfilDetalle();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el perfil: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updatePerfil(){
            var promise = PerfilesAsientoService.updatePerfil(vm.perfil);
            
            promise
            .then(function(response){
                logger.success('Perfil modificado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el perfil: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearPerfilData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.perfil = {
                id: 0,
                companiaId: UserInfoService.getCompaniaId(),
                nombre: ''
            };
            // Set back to pristine.
            $scope.perfilForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.perfilForm.$setUntouched();
        };

        vm.saveDetalle = function(){

            $scope.submittedDetalle = true;

            doFormDetalleValidations();
            
            if($scope.perfilDetalleForm.$valid){
                if(!vm.perfilDetalle.id){
                    savePerfilDetalle();
                }
                else if($scope.perfilDetalleForm.$dirty){
                    updatePerfilDetalle();
                }
                else{
                    logger.info('No has modificado ningún dato del detalle!');
                }
            }     
        
        };

        function savePerfilDetalle() {
            var promise = PerfilesAsientoService.savePerfilDetalle(vm.perfilDetalle);
            
            promise
            .then(function(response){
                logger.success('Detalle creado con éxito.');
                clearPerfilDetalleData();
                getPerfilDetalle();
                vm.editandoDetalle = false;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el detalle del perfil: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updatePerfilDetalle(){
            var promise = PerfilesAsientoService.updatePerfilDetalle(vm.perfilDetalle);
            
            promise
            .then(function(response){
                logger.success('Detalle modificado con éxito.');
                clearPerfilDetalleData();
                getPerfilDetalle();
                vm.editandoDetalle = false;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el detalle del perfil: ' + error.data.Message);
                        break;
                }
            });   
        };

        vm.deleteDetalle = function(detalle){
            var promise = PerfilesAsientoService.removePerfilDetalle(detalle);
            
            promise
            .then(function(response){
                vm.detalles = vm.detalles.filter(function(g) {
                    return g.id !== detalle.id;
                });
                clearPerfilDetalleData();
                getPerfilDetalle();
                vm.editandoDetalle = false;
                logger.success('Detalle eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Detalle');
                        break;
                }
                
            });   
        };

        function clearPerfilDetalleData(){
            $scope.submittedDetalle = false;
            // Reset the form model.
            vm.perfilDetalle = {
                companiaId: UserInfoService.getCompaniaId(),
                tipoRubro: -1,
                rubroId: -1,
                cuentaMayor: -1,
                cuentaAsociadaDebitos: -1,
                cuentaAsociadaCreditos: -1,
                perfilId: vm.perfilId,
                centroCostoId: -1,
                valorBruto: 0,
                producto: '',
                finca: '',
                lote: ''
            };
            // Set back to pristine.
            $scope.perfilDetalleForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.perfilDetalleForm.$setUntouched();
        };

        vm.cargarDetalle = function(d){
            if(d){
                d.cuentaMayor = d.cuentaMayor == null ? -1 : d.cuentaMayor;
                d.cuentaAsociadaDebitos = d.cuentaAsociadaDebitos == null ? -1 : d.cuentaAsociadaDebitos;
                d.cuentaAsociadaCreditos = d.cuentaAsociadaCreditos == null ? -1 : d.cuentaAsociadaCreditos;

                vm.perfilDetalle = d;
                vm.editandoDetalle = true;
                $animationsSrv.scrollToTop();
            }
        };

        vm.nuevoDetalle = function(){
            clearPerfilDetalleData();
            vm.editandoDetalle = false;
        };

    }
})();